import { GET_ROUTE_ERR, GET_ROUTE_REQ, GET_ROUTE_RES } from '../constants';
import { handleAsync } from './reducerUtils';

const initState = {
  route: '',
  route_loaded: false,
  errors: [],
};

const reducer = (state = initState, action) => {
  const next = handleAsync(state, action, { req: GET_ROUTE_REQ, res: GET_ROUTE_RES, err: GET_ROUTE_ERR, dataKey: 'route' });
  if (next) return next;

  switch (action.type) {
    default:
      return state;
  }
};

export default reducer;
